/* Prelaunch-theme frame renderer (live theme 190380703787, snapshot 10-08), unchanged except the global name: demand-loads the few frames around the scroll position at a CDN size that fits, draws the nearest one, no easing; tries the short-GOP alpha video first (ronini-scroll-video.js). Desktop engine of sections/scrolling-image-cards.liquid (owner 10-12: "do it the prelaunch way"). */
(function () {
  if (window.RoniniScrollFramesPL) return;
  window.RoniniScrollFramesPL = function (image, scene, imageOnly) {
    let urls;
    try { urls = JSON.parse(image.dataset.frames || '[]'); } catch (_) { urls = []; }
    if (!Array.isArray(urls) || !urls.length || urls.some(url => typeof url !== 'string')) return null;
    if (!imageOnly && window.RoniniScrollVideo) {
      const video = window.RoniniScrollVideo(image, scene, () => window.RoniniScrollFramesPL(image, scene, true), urls.length);
      if (video) return video;
    }
    const canvas = document.createElement('canvas');
    canvas.className = 'sticky-scene-image js-scroll-canvas is-active';
    canvas.setAttribute('aria-hidden', 'true');
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    image.after(canvas);
    const mobile = window.matchMedia('(max-width: 991px)');
    const cache = new Map(), pending = new Set(), failures = new Map(), requests = new Map();
    let active = 0, near = false, enabled = true, destroyed = false, generation = 0;
    let target = 0, direction = 1, progress = 0, size = 0, cw = 0, ch = 0, raf = 0, painted = '', frameBytes = 0;
    const memory = () => (mobile.matches ? 20 : 48) * 1024 * 1024;
    const maxFrames = () => mobile.matches ? 8 : 12;
    const working = () => near && enabled && !destroyed && !document.hidden;
    const startAt = () => (image.dataset.start ? Math.max(0, Math.min(urls.length - 1, Number(image.dataset.start) || 0)) : mobile.matches ? Math.min(5, urls.length - 1) : 0);
    function release(bmp) { if (!bmp) return; if (bmp.close) bmp.close(); else { bmp.onload = bmp.onerror = null; bmp.src = ''; } }
    function clear() {
      generation += 1;
      requests.forEach((request, cancel) => cancel());
      requests.clear(); pending.clear(); failures.clear();
      cache.forEach(release); cache.clear(); frameBytes = 0; painted = '';
      cancelAnimationFrame(raf); raf = 0;
      ctx.clearRect(0, 0, cw, ch); image.style.opacity = '';
    }
    function measure() {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const width = Math.round(image.clientWidth * dpr), height = Math.round(image.clientHeight * dpr);
      if (!width || !height) return;
      // CDN transformations retain the exact source frames, at a fitting size.
      const drawnWidth = mobile.matches ? Math.max(width, height * 16 / 9) : Math.min(width, height * 16 / 9);
      const nextSize = drawnWidth <= 960 ? 960 : drawnWidth <= 1600 ? 1600 : 2560;
      if (size && size !== nextSize) clear();
      size = nextSize;
      if (cw !== width || ch !== height) { cw = canvas.width = width; ch = canvas.height = height; painted = ''; }
    }
    function url(index) { return size === 2560 ? urls[index] : urls[index].replace(/\.webp(?=\?|$)/i, '_' + size + 'x.webp'); }
    function wanted() {
      const limit = Math.max(1, Math.min(7, maxFrames(), Math.floor(memory() / (frameBytes || size * size * 9 / 16 * 4))));
      const result = [], start = startAt();
      const add = i => { if (i >= start && i < urls.length && result.length < limit && !result.includes(i)) result.push(i); };
      add(target);
      for (let distance = 1; result.length < limit && distance < urls.length * 2; distance++) {
        add(target + direction * distance);
        if (distance % 2 === 0) add(target - direction * distance / 2);
      }
      return result;
    }
    function bytes(bmp) { return (bmp.width || bmp.naturalWidth) * (bmp.height || bmp.naturalHeight) * 4; }
    function prune() {
      const wants = wanted(); let total = 0;
      [...cache.keys()].sort((a, b) => Number(wants.includes(b)) - Number(wants.includes(a)) || Math.abs(a - target) - Math.abs(b - target)).forEach((index, rank) => {
        const bmp = cache.get(index), length = bytes(bmp);
        if (rank >= maxFrames() || (rank > 0 && total + length > memory())) { release(bmp); cache.delete(index); }
        else total += length;
      });
    }
    function load(index) {
      return new Promise((resolve, reject) => {
        const img = new Image(), request = { index, decoding: false };
        let settled = false, discarded = null;
        const finish = (error, bmp) => {
          if (settled) { release(bmp); return; }
          settled = true; clearTimeout(timer); requests.delete(cancel); img.onload = img.onerror = null;
          if (error) { release(bmp); img.src = ''; reject(error); }
          else { if (bmp !== img) img.src = ''; resolve(bmp); }
        };
        const fail = error => {
          if (settled) return;
          if (request.decoding) { discarded = error; clearTimeout(timer); }
          else finish(error);
        };
        const cancel = () => { const e = new Error('Frame cancelled'); e.cancelled = true; fail(e); };
        const timer = setTimeout(() => fail(new Error('Frame timed out')), 8000);
        requests.set(cancel, request);
        img.decoding = 'async'; img.fetchPriority = index === target ? 'auto' : 'low';
        img.onload = () => {
          request.decoding = true; img.onload = img.onerror = null;
          const ready = img.decode ? img.decode().catch(() => {}) : Promise.resolve();
          ready.then(() => {
            if (discarded) throw discarded;
            if (!window.createImageBitmap) return img;
            const fit = mobile.matches ? Math.max(cw / img.naturalWidth, ch / img.naturalHeight) : Math.min(cw / img.naturalWidth, ch / img.naturalHeight);
            const scale = Math.min(1, fit);
            return createImageBitmap(img, { resizeWidth: Math.max(1, Math.ceil(img.naturalWidth * scale)), resizeHeight: Math.max(1, Math.ceil(img.naturalHeight * scale)), resizeQuality: 'high' }).catch(() => {
              if (discarded) throw discarded;
              return createImageBitmap(img).catch(() => img);
            });
          }).then(bmp => finish(discarded, bmp), error => finish(discarded || error));
        };
        img.onerror = () => fail(new Error('Frame failed'));
        img.src = url(index);
      });
    }
    function draw() {
      raf = 0;
      if (!working() || !cache.size) return;
      const index = [...cache.keys()].sort((a, b) => Math.abs(a - target) - Math.abs(b - target))[0];
      const key = `${generation}:${index}:${cw}:${ch}`;
      if (painted === key) return;
      const bmp = cache.get(index), width = bmp.width || bmp.naturalWidth, height = bmp.height || bmp.naturalHeight;
      const scale = mobile.matches ? Math.max(cw / width, ch / height) : Math.min(cw / width, ch / height);
      ctx.clearRect(0, 0, cw, ch);
      ctx.drawImage(bmp, (cw - width * scale) / 2, mobile.matches ? (ch - height * scale) / 2 : 0, width * scale, height * scale);
      image.style.opacity = '0'; painted = key;
    }
    function paint() { if (working() && !raf) raf = requestAnimationFrame(draw); }
    function pump() {
      if (!working() || !size) return;
      const wants = wanted(); let progressRequest = false;
      requests.forEach((request, cancel) => {
        if (!progressRequest) { progressRequest = true; return; }
        if (!request.decoding && !wants.includes(request.index)) cancel();
      });
      while (active < (mobile.matches ? 2 : 3)) {
        const index = wants.find(i => !cache.has(i) && !pending.has(i) && (failures.get(i) || 0) < 2);
        if (index === undefined) break;
        const epoch = generation; pending.add(index); active += 1;
        load(index).then(bmp => {
          if (epoch !== generation || !working()) { release(bmp); return; }
          frameBytes = Math.max(frameBytes, bytes(bmp)); cache.set(index, bmp); prune(); paint();
        }).catch(error => { if (epoch === generation && !error.cancelled) failures.set(index, (failures.get(index) || 0) + 1); }).finally(() => {
          if (epoch === generation) pending.delete(index);
          active -= 1; pump();
        });
      }
    }
    function setProgress(value) {
      progress = Math.max(0, Math.min(1, Number(value) || 0));
      const start = startAt();
      const next = start + Math.round(progress * (urls.length - start - 1));
      if (next !== target) direction = next > target ? 1 : -1;
      target = next;
      image.dataset.lastScrollProgress = String(progress);
      for (const el of [image, canvas]) el.classList.toggle('is-scroll-visible', mobile.matches || target > 0);
      pump(); paint();
    }
    function refresh() { measure(); setProgress(progress); prune(); }
    const onVisibility = () => { if (document.hidden) clear(); else { refresh(); pump(); } };
    document.addEventListener('visibilitychange', onVisibility);
    let observer;
    if (window.IntersectionObserver) {
      observer = new IntersectionObserver(entries => { near = entries.some(e => e.isIntersecting); if (!near) clear(); else { refresh(); pump(); } }, { rootMargin: '50% 0px' });
      observer.observe(scene);
    } else near = true;
    measure(); setProgress(0);
    return {
      setProgress, refresh,
      setEnabled(value) { enabled = value; if (!enabled) clear(); else refresh(); },
      destroy() { destroyed = true; clear(); observer?.disconnect(); document.removeEventListener('visibilitychange', onVisibility); canvas.remove(); }
    };
  };
})();
